import UseCase from "core/useCase/UseCase";
import { AppleWalletPass, WalletPassParams } from "domain/entity/WalletPass";
import { WalletRepository } from "domain/repository/WalletRepository";

export default class GetAppleWalletPassUseCase extends UseCase<
  AppleWalletPass,
  WalletPassParams
> {
  private repository: WalletRepository;

  constructor(repository: WalletRepository) {
    super();
    this.repository = repository;
  }

  execute = (params: WalletPassParams) =>
    this.repository.getAppleWalletPass(params);
}
